module.exports = __webpack_public_path__ + "img/list1.801db883.png";